module.exports = __webpack_public_path__ + "img/tarj1-3.0d716ff0.svg";